import React, { createContext, useCallback, useContext, useState } from "react";

/**
 * Shell state shared by Sidebar and Header.
 *
 * Every admin screen renders <Sidebar /> and <Header /> as siblings, so the
 * mobile drawer used to be coordinated by toggling a class on the DOM with
 * jQuery from Header while Sidebar watched for outside clicks. The provider
 * sits in PrivateRouter, above both, so the two can share React state instead.
 */
const AdminShellContext = createContext({
  drawerOpen: false,
  toggleDrawer: () => {},
  closeDrawer: () => {},
});

export const useAdminShell = () => useContext(AdminShellContext);

export const AdminShellProvider = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = useCallback(() => setDrawerOpen((open) => !open), []);
  const closeDrawer = useCallback(() => setDrawerOpen(false), []);

  return (
    <AdminShellContext.Provider
      value={{ drawerOpen, toggleDrawer, closeDrawer }}
    >
      {children}
    </AdminShellContext.Provider>
  );
};

export default AdminShellContext;
